"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useToggleMenu = void 0;
var ToggleMenuFlyout = _interopRequireWildcard(require("@ori-events/toggle-menu-flyout"));
var UserAction = _interopRequireWildcard(require("@ori-events/user-action"));
var _constants = require("../constants");
var _activeMenuContext = require("../context/navigation/activeMenuContext");
var _utils = require("../utils");
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (_interopRequireWildcard = function (e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        default: e
      };
    if (null === e || "object" != typeof e && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
    return f;
  })(e, t);
}
const toggleMenu = menuIsOpen => () => {
  if (!menuIsOpen) {
    UserAction.dispatch(_constants.CLICK_BURGER_MENU);
  }
  (0, _utils.dispatchToggleMenu)(ToggleMenuFlyout.MenuTypes.BurgerMenu);
};
const useToggleMenu = () => {
  const {
    activeMenu
  } = (0, _activeMenuContext.useActiveMenu)();
  const isOpen = activeMenu === ToggleMenuFlyout.MenuTypes.BurgerMenu;
  return {
    isOpen,
    toggleMenu: toggleMenu(isOpen)
  };
};
exports.useToggleMenu = useToggleMenu;